import React from "react";
import { Box, Button, InputBase, IconButton } from "@mui/material";
import { SearchOutlined, AddCircleOutlineOutlined } from "@mui/icons-material";

interface StreamListHeader2Props {
  inputValue: string;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onSearch: () => void;
  onAddStream: () => void;
  hasAddPermission?: boolean;
}

const StreamListHeader2: React.FC<StreamListHeader2Props> = ({
  inputValue,
  onInputChange,
  onKeyDown,
  onSearch,
  onAddStream,
  hasAddPermission,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "background.paper",
          border: "1px solid gray",
          px: 1,
          borderRadius: "10px",
        }}
      >
        <InputBase
          placeholder="Search..."
          value={inputValue}
          onChange={onInputChange}
          onKeyDown={onKeyDown}
          sx={{ flex: 1, fontSize: "14px", minWidth: "300px" }}
        />
        <IconButton size="small" onClick={onSearch}>
          <SearchOutlined sx={{ fontSize: "20px", color: "text.secondary" }} />
        </IconButton>
      </Box>

      {hasAddPermission && (
        <Button
          variant="contained"
          startIcon={<AddCircleOutlineOutlined />}
          onClick={onAddStream}
          sx={{
            backgroundColor: "#614438",
            color: "#fff",
            textTransform: "none",
            fontWeight: 500,
            borderRadius: "8px",
            "&:hover": { backgroundColor: "#aa7b67" },
          }}
        >
          Add Stream
        </Button>
      )}
    </Box>
  );
};

export default StreamListHeader2;
